export const useIsServer = () => typeof window === 'undefined'